var setup = function setup() {
  return new Promise(function (resolve) {
    var _window$__Cohesion2;
    document.addEventListener("makeLoaded", function () {
      var _window$__Cohesion;
      if ((_window$__Cohesion = window.__Cohesion) !== null && _window$__Cohesion !== void 0 && _window$__Cohesion.initialized) {
        console.log("%c @analytics/make - ready", "color: cornflowerblue;");
        resolve();
      }
    });
    if (!((_window$__Cohesion2 = window.__Cohesion) !== null && _window$__Cohesion2 !== void 0 && _window$__Cohesion2.initialized)) {
      var _JSON$parse;
      var makeTagular = (_JSON$parse = JSON.parse(localStorage.getItem("@mobi/analytics"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.makeTagular;
      var style = document.createElement("style");
      var script = document.createElement("script");
      style.innerText = ".preampjs [data-preamp], .fusejs [data-fuse] {opacity: 0 !important}";
      document.head.append(style);
      script.innerText = "!function(co,h,e,s,i,o,n){var d='documentElement';var a='className';h[d][a]+=' preampjs fusejs';\n      n.k=e;co._Cohesion=n;co._Preamp={k:s,start:new Date};co._Fuse={k:i};co._Tagular={k:o};\n      [e,s,i,o].map(function(x){co[x]=co[x]||function(){(co[x].q=co[x].q||[]).push([].slice.call(arguments))}});\n      h.addEventListener('DOMContentLoaded',function(){co.setTimeout(function(){\n      var u=h[d][a];h[d][a]=u.replace(/ ?preampjs| ?fusejs/g,'')},3e3);\n      co._Preamp.docReady=co._Fuse.docReady=!0});var z=h.createElement('script');\n      z.async=1;z.src='https://cdn.cohesionapps.com/cohesion/cohesion-latest.min.js';z.onload=" + function () {
        document.dispatchEvent(new Event("makeLoaded"));
      } + ";h.head.appendChild(z);}\n      (window,document,'cohesion','preamp','fuse','tagular',{\n          tagular:{writeKey: '" + makeTagular.writeKey + "', sourceKey: '" + makeTagular.sourceKey + "', beamHook:function(event){window.dataLayer=window.dataLayer||[];window.dataLayer.push({\"event\":event[\"@type\"],\"tagularPayload\":event})}},\n      })";
      document.head.append(script);
    } else {
      resolve();
    }
  });
};
export default setup;